import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card statistics" }
const _hoisted_2 = { class: "grid" }
const _hoisted_3 = { class: "col-12 lg:col-6" }
const _hoisted_4 = { class: "statistic-item" }
const _hoisted_5 = { class: "item-title" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "col-12 lg:col-6" }
const _hoisted_8 = { class: "statistic-item" }
const _hoisted_9 = { class: "item-title" }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h6", null, "Laravel Jobs")
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[0] || (_cache[0] = _createElementVNode("span", null, "⚙", -1)),
            (_ctx.jobsCountersLoading)
              ? (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
                  key: 0,
                  height: "15px"
                }))
              : (_openBlock(), _createElementBlock("h5", _hoisted_6, _toDisplayString(_ctx.jobsCounters.jobs), 1))
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('jobs')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _cache[1] || (_cache[1] = _createElementVNode("span", null, "🚨", -1)),
            (_ctx.jobsCountersLoading)
              ? (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
                  key: 0,
                  height: "15px"
                }))
              : (_openBlock(), _createElementBlock("h5", _hoisted_10, _toDisplayString(_ctx.jobsCounters.failed_jobs), 1))
          ]),
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('failed_jobs')), 1)
        ])
      ])
    ])
  ]))
}